import { pushRegistrar } from "pushNotifications";
import { clearSession } from "utils/organizationAccess";
import { clearClockSettingsCache, getCurrentUserId } from "utils/clockSettings";

export const signOut = ({ queryClient, navigate } = {}) => {
  const userId = getCurrentUserId();
  // Captures the auth token synchronously, so it is safe that the session is cleared right after.
  pushRegistrar.release();
  queryClient?.clear();
  clearClockSettingsCache(userId);
  clearSession();
  navigate?.("/");
};
